/**
 * @module Actions.SubscriptionPlan
 *
 */
import { Dispatch } from 'react';
import { action, ActionType } from 'typesafe-actions';
import { RequestError } from 'typedefs';
import { SubscriptionPlanModel } from 'app/models';
import { fetchGet } from 'app/utils/request';

// Each phase names the currency it was asked for, so the reducer can tell a
// response for the currency on screen from a superseded one.
const pending = (currency: string) => action('@subscription-plan.fetch.pending', currency);
const error = (error: RequestError, currency: string) =>
  action('@subscription-plan.fetch.error', { error, currency });
const success = (plans: SubscriptionPlanModel[], currency: string) =>
  action('@subscription-plan.fetch.success', { plans, currency });

const actionHandlers = { pending, error, success };

export type SubscriptionPlanAction = ActionType<typeof actionHandlers>;

// The plans priced in a currency, USD unless asked otherwise
export const fetchPlans = (currency = 'usd') => {
  return (dispatch: Dispatch<SubscriptionPlanAction>) => {
    dispatch(pending(currency));

    return fetchGet('stripe/plans', { currency }, { version: 1 })
      .then((data: { plans: SubscriptionPlanModel[]}) => dispatch(success(data.plans, currency)))
      .catch(err => dispatch(error(err, currency)));
  };
};

export const actions = {
  fetchPlans,
};
